import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconCd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconCd"><Circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><Path d="M10.2473 6.26025C8.3406 6.84176 6.83684 8.3473 6.25781 10.2551M17.7418 13.7472C17.1622 15.6544 15.6584 17.1594 13.7518 17.7404" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Circle cx="12" cy="12" r="2.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconCd;
